"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveConfig = void 0;
const resolveConfig_1 = __importDefault(require("tailwindcss/resolveConfig"));
function resolveConfig(config) {
    const resolved = (0, resolveConfig_1.default)(config);
    return Object.assign(Object.assign({}, resolved), { prefix: resolved.prefix || '', separator: resolved.separator || ':', corePlugins: resolved['corePlugins'].reduce((prev, current) => {
            prev[current] = true;
            return prev;
        }, {}) });
}
exports.resolveConfig = resolveConfig;
